import Vue from 'vue'
import VueRouter from 'vue-router'

const Location = () => import(/* webpackChunkName: "Location" */'./layouts/map/Location.vue')
const LocationFilter = () => import(/* webpackChunkName: "LocationFilter" */'./layouts/map/LocationFilter.vue')
const CategoryResults = () => import(/* webpackChunkName: "CategoryResults" */'./layouts/map/CategoryResults.vue')

export const routes = [
  {
    path: '/m/:lat?/:lng?/:pitch?/:bearing?/:zoom?',
    component: LocationFilter,
    name: 'filter',
  },
  {
    path: '/c/:categoryId/:lat?/:lng?/:pitch?/:bearing?/:zoom?',
    component: CategoryResults,
    name: 'category',
    props: true,
  },
  {
    path: '/location/:locationId/:lat?/:lng?/:pitch?/:bearing?/:zoom?',
    component: Location,
    name: 'location',
    props: true,
  },
  { path: '*', redirect: '/m/' },
]

export let router

if (typeof ROUTER_BASE_PATH !== 'undefined') {
  Vue.use(VueRouter)
  router = new VueRouter({
    base: ROUTER_BASE_PATH,
    routes,
  })
}

